import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectFilteredCreditCardOptions } from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.selectors'
import CreditCardDropdown, { CreditCardDropdownInfiniteScrollProps } from 'src/components/CreditCardDropdown/CreditCardDropdown'
import { useExtendLocation } from 'src/hooks/locationHooks'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { useQueryCreditCards } from 'src/queries/creditCard.queries'
import { defaultQueryCacheOptions } from 'src/queries/queries.constants'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface AccountFilterProps {
  creditCardSet: Set<string>
  handleCreditCardSelection: (cardId: string) => Set<string>
  setCreditCardSet: (cards: Set<string>) => void
  defaultFilters: {
    creditCardId?: Set<string>
  }
}

const AccountFilter: React.FC<AccountFilterProps> = ({
  creditCardSet,
  handleCreditCardSelection,
  setCreditCardSet,
  defaultFilters,
}) => {
  const extendLocation = useExtendLocation()

  const locale = useSelector(selectNullSafeLocaleFromState)

  // creditCards
  const creditCardOptions = useSelector(selectFilteredCreditCardOptions)
  const [accountSearch, setAccountSearch] = useState('')

  const {
    data,
    isLoading,
    fetchNextPage,
    complete: creditCardsComplete,
  } = useQueryCreditCards({
    filters: {
      search: accountSearch,
      count: 100,
      sortField: 'type',
      sortDirection: 'ASC',
    },
    queryCacheOptions: defaultQueryCacheOptions,
    additionalKey: extendLocation.matchedPath,
  })

  const currentPage = data?.page ?? 0

  const creditCardInfiniteScrollProps: CreditCardDropdownInfiniteScrollProps = {
    // TODO: suboptimal -  could do a better job at making react query abstract this away so we don't have
    // to maintain this kind of logic in every implementation of the infinite query later on down the line
    fetch: (filterInput, requestedPage) => {
      const q = (filterInput ?? '').trim()
      const target = requestedPage ?? 0
      if (target === 0) {
        if (q !== accountSearch) setAccountSearch(q)
        return
      }
      if (
        q === accountSearch &&
        target > currentPage &&
        !isLoading &&
        !creditCardsComplete
      ) {
        fetchNextPage()
      }
    },
    page: data?.page,
    loading: isLoading,
    complete: creditCardsComplete,
  }

  return (
    <>
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Accounts'} />
      </div>
      <CreditCardDropdown
        css={css`
          margin-top: 8px;
        `}
        placeholder={translateSingleString(locale, 'All accounts')}
        chooseOption={(val: string): void => {
          handleCreditCardSelection(val)
        }}
        isMulti={true}
        selectedValues={creditCardSet}
        optionGroups={[
          {
            options: creditCardOptions || [],
          },
        ]}
        onResetClick={(): void => {
          setCreditCardSet(defaultFilters.creditCardId || new Set<string>())
        }}
        infiniteScrollProps={creditCardInfiniteScrollProps}
      />
    </>
  )
}

export default AccountFilter
